import gql from 'graphql-tag'

const mutation = gql`
mutation createDepartment($fields: DepartmentInput!) {
	cashAssist {
	  createDepartment(fields: $fields) {
	    id
	    mod_ver
	    name
	  }
	}
}
`

export default mutation
